import { useBreadcrumb } from "core/features/breadcrumbs";
import ConteudoCalendarioDepositos from "./components/ConteudoCalendarioDepositos";

function CalendarioDepositosListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Calendário de depósitos",
      url: "/financeiro/calendario-depositos",
    },
  ]);

  return <ConteudoCalendarioDepositos />;
}

export default CalendarioDepositosListagemPage;
